import React from 'react';

const BadRoute = (): JSX.Element => {
  return <div>Bad Route</div>;
};

export default BadRoute;
